<template>
  <!-- app主框架 -->
  <v-content>
    <main-alert-message />
    <main-menu v-if="!isFudaoConnected" ref="menu" />

    <div class="main-container">
      <!-- 左頁 -->
      <transition name="fade" mode="out-in" type="transition">
        <keep-alive :exclude="['Profile', 'Settings']">
          <router-view class="left-page"></router-view>
        </keep-alive>
      </transition>

      <!-- 右頁 -->
      <div v-if="!fullPage" class="right-page">
        <app-resizer edge="left" width="4px" />
        <transition name="fade" mode="out-in" type="transition">
          <components :is="rightPage" />
        </transition>
      </div>
    </div>

    <fudao-teacher-invite-dialog v-if="isTeacher" />
    <fudao-student-invite-dialog v-if="isStudent" />

    <fudao-evaluate-student-dialog v-if="isTeacher" :showCancelBtn="false" />
    <fudao-evaluate-teacher-dialog v-if="isStudent" />
  </v-content>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex';

import MainMenu from './MainMenu';
import MainAlertMessage from './MainAlertMessage';
import rightPages from '@/router/right-pages';

import FudaoTeacherInviteDialog from '../Fudao/FudaoTeacherInviteDialog';
import FudaoStudentInviteDialog from '../Fudao/FudaoStudentInviteDialog';
import FudaoEvaluateStudentDialog from '../Fudao/FudaoEvaluateStudentDialog';
import FudaoEvaluateTeacherDialog from '../Fudao/FudaoEvaluateTeacherDialog';

export default {
  components: {
    'main-menu': MainMenu,
    'main-alert-message': MainAlertMessage,
    'fudao-teacher-invite-dialog': FudaoTeacherInviteDialog,
    'fudao-student-invite-dialog': FudaoStudentInviteDialog,
    'fudao-evaluate-student-dialog': FudaoEvaluateStudentDialog,
    'fudao-evaluate-teacher-dialog': FudaoEvaluateTeacherDialog,
    ...rightPages
  },

  computed: {
    ...mapState({
      rightPage: state => state.rightPage,
      userid: state => state.userid
    }),

    ...mapGetters('fudao', {
      isFudaoConnected: 'isFudaoConnected'
    }),

    fullPage() {
      return this.$route.matched.reduce((accumulator, currentValue) => {
        return currentValue.meta.layout === 'full' || accumulator;
      }, false);
    }
  },

  watch: {
    async userid(v) {
      if (!v) {
        return;
      }

      try {
        await this.initAppData();
      } catch (e) {
        // TODO retry
      }
    }
  },

  mounted() {
    document.querySelector('html').classList.add('overflow-hidden');
    if (!this.userid) {
      return;
    }
    this.initAppData();
  },

  beforeDestroy() {
    document.querySelector('html').classList.remove('overflow-hidden');
  },

  methods: {
    ...mapActions(['initAppData']),

    toggleSidenav() {
      this.$refs.menu.toggle();
    },
    toggleChat() {
      this.$refs.chat.toggle();
    }
  }
};
</script>

<style lang="stylus" scoped>

.main-container {
  display: flex;
  align-items: stretch;
  height: 100vh;
  background-color: white;
  // background-color: $def-bg-color;
}

.left-page {
  flex-grow: 1;
  flex-basis: 0;
}

.right-page {
  border-left: 1px solid darken($secondary-color, 10%);
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 60vw;
}
</style>

